import _toConsumableArray from "@babel/runtime/helpers/esm/toConsumableArray";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.find.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.string.pad-start.js";
import "core-js/modules/web.timers.js";
export function selectDate(elementRef, targetDate) {
  return waitForDates(elementRef).then(function (entryDates) {
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-expect-error
    var currentDate = entryDates.find(function (el) {
      var ariaLabel = el.getAttribute('aria-label');
      return ariaLabel && formatDate(ariaLabel) === targetDate;
    });
    if (currentDate) {
      currentDate.classList.add('selected');
    } else {
      console.log('Current date not found');
    }
  }).catch(function (error) {
    return Promise.reject(error);
  });
}
function waitForDates(ref) {
  return new Promise(function (resolve, reject) {
    var interval = setInterval(function () {
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-expect-error
      var entryDates = _toConsumableArray(ref.querySelectorAll('.flatpickr-day:not(.hidden)'));
      if (entryDates.length > 0) {
        clearInterval(interval);
        resolve(entryDates);
      }
    }, 100);
    setTimeout(function () {
      clearInterval(interval);
      reject('Elements not found in time');
    }, 5000);
  });
}
function formatDate(dateStr) {
  var date = new Date(dateStr);
  var year = date.getFullYear();
  var month = String(date.getMonth() + 1).padStart(2, '0');
  var day = String(date.getDate()).padStart(2, '0');
  return "".concat(year, "-").concat(month, "-").concat(day);
}